import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../api/ApiService';
import { arrayUniqueFilter } from '../../utils';

import Image from '../../../../../containers/assets/instructor-successful-teams3.png'

import BannerLayout from '../../layouts/banner';

class NetLoss extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShowCount: 0,
      allTeamsCount: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { performanceFeedbacksGame } = this.props;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {

      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Negative profits").teams.filter(arrayUniqueFilter);

      const teams = res.body;

      this.setState({
        loaded: true,
        teamsToShowCount: teamsToShowIds.length,
        allTeamsCount: teams.length
      })
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShowCount,
      allTeamsCount
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Net Loss"
        alertText={`${teamsToShowCount} out of ${allTeamsCount} teams didn’t make a profit`}
        previousShownErrors={previousShownErrors}
        paragraph1={(
          <p>These teams incurred expenses that exceeded their revenues, As a result, they were unable to hit any of the profitability targets (e.g. ROE, ROA, or EPS).</p>
        )}
        paragraph2={(
          <Fragment>
            <p><strong>Common reasons why teams were unable to make a profit:</strong></p>
            <p><strong>Revenue Challenges:</strong> A mix of marketing mix and/or capacity challenges might have led to lower revenues (e.g. lower ranking products, less productive machines).</p>
            <p><strong>Operating Margin Challenges:</strong> There’s likely margin compression due to teams upgrading to higher quality products and at the same  time dropping their selling prices.</p>
            <p><strong>High Financing Costs:</strong> Some teams took on a lot of debt in the earlier rounds and are unable to repay. They are feeling the impact now as a result of the metrics shifting to profit driven metrics.</p>
          </Fragment>
        )}
        visual={(
          <img src={Image} alt='Income Statement' />
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#D7F0F2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default NetLoss;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/net-loss.js